import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, switchMap, first } from 'rxjs/operators';
import { SpinnerService } from 'src/app/core/services/spinner/spinner.service';
import { updateCoverageStatus } from 'src/app/state/coverages/coverages.actions';
import { ICoverage } from 'src/app/state/coverages/coverages.models';
import { selectCoverages } from 'src/app/state/coverages/coverages.selectors';
import { IObject } from 'src/app/state/objects/objects.models';
import { selectSelectedObject } from 'src/app/state/objects/objects.selectors';
import { updateQuotationPrice } from 'src/app/state/quotation/quotation.actions';
import { IQuotation } from 'src/app/state/quotation/quotation.models';
import { selectQuotation } from 'src/app/state/quotation/quotation.selectors';
import { GlobalDialogComponent } from '../globaldialog/globaldialog.component';
import { environment } from 'src/environments/environment';
import { CotizacionService } from 'src/app/core/http/apiPricing/cotizacion.service';
import { ObjetosService } from 'src/app/core/http/apiProducto/objetos.service';
import { LandingService } from 'src/app/core/http/apiLanding/landing.service';
import { OfertasService } from 'src/app/core/http/apiPricing/ofertas.service';

export interface IDropDownCoverage extends ICoverage {
  title?: string;
  IsHidden?: boolean;
  mandatory?: boolean;
}

@Component({
  selector: 'app-coverages-drop-downs',
  templateUrl: './coverages-drop-downs.component.html',
  styleUrls: ['./coverages-drop-downs.component.scss']
})
export class CoveragesDropDownsComponent implements OnInit {

  @Input() isReadOnly: boolean
  @Input() coveragesData: IDropDownCoverage[]
  @Input() coveragesContract: IDropDownCoverage[]
  @Input() proxyEnabled: boolean = false;
  @Output() OptionalCoverages = new EventEmitter<string>();

  coverages$: Observable<IDropDownCoverage[]>;
  quotation$: Observable<IQuotation>;
  selectedObject$: Observable<IObject>;

  proxy_enabled = environment.proxy.enabled;


  constructor(
    private dialog: MatDialog,
    private objetosService: ObjetosService,
    private ofertasService: OfertasService,
    private cotizacionService: CotizacionService,
    private spinnerService: SpinnerService,
    private store: Store) { }

  ngOnInit(): void {
    this.quotation$ = this.store.select(selectQuotation);
    this.selectedObject$ = this.store.select(selectSelectedObject);
    this.coverages$ = this.store.select(selectCoverages)
      .pipe(
        map(coverages => coverages
          .filter(coverage => coverage.idModalidad !== 86 && coverage.idModalidad !== 81) //si idModalidad = 86 y 81, elimina la covertura de la lista
          .map(coverage => ({
            ...coverage,
            title: coverage.descripcion,
            IsHidden: true,
            details: coverage.details || [],
            mandatory: coverage.mandatory,
            price: coverage.coste,
            activada: false
          }))
        )
      );
  }

  onSelect(coverage: IDropDownCoverage, selectedObject: IObject) {
    this.getCoverageInfoText(coverage, selectedObject).subscribe(coverage_details => {
      coverage.details = coverage_details;
      coverage.IsHidden = !coverage.IsHidden;
    });
  }

  getCoverageInfoText(coverage: IDropDownCoverage, selectedObject: IObject) {
    const coverage_alias = this.getAPICoverageAlias(coverage.aliasCobertura);
    return this.objetosService.getCoverageInfoText(coverage_alias, selectedObject.idProducto)
      .pipe(
        first(),
        switchMap(resp => {
          return of(resp.data.sort((objectA, objectB) => {
            return objectA.nivel - objectB.nivel || objectA.orden - objectB.orden
          }));
        })
      )
  }

  // Se crea esta funcion SOLO PARA MOCK, no deberia existir. 
  // ToDo: Cuadrar con funcional que campo habría que usar de la base de datos en vez de este switch
  getAPICoverageAlias(aliasCobertura: string) {
    switch (aliasCobertura) {
      case "Robo": return "roboYPerdida";
      case "Daños materiales": return "DetCobDaños";
      case "NoAsistencia": return "DetCobNoAsist";
      default: return aliasCobertura;
    }
  }

  verify(coverage: IDropDownCoverage, quotation: IQuotation) {
    coverage.seleccionada = !coverage.seleccionada;
    this.spinnerService.show();
    this.store.dispatch(updateCoverageStatus({ id: coverage.id, status: { seleccionada: coverage.seleccionada, activada: true } }));
    this.ofertasService.seleccionarOferta(coverage.id, true, coverage.seleccionada, this.proxyEnabled).subscribe(_ => {
      this.cotizacionService.retarificar(quotation.idCotizacion, 1)
        .subscribe({
          next: resp => this.store.dispatch(updateQuotationPrice({ price: resp.data.new.anual })),
          complete: () => this.spinnerService.hide()
        });
    }, _ => this.spinnerService.hide())
  }

  InfoDialog(coverage, selectedObject) {
    this.getCoverageInfoText(coverage, selectedObject).subscribe(coverage_details => {
      coverage.details = coverage_details;

      const dialogRef = this.dialog.open(GlobalDialogComponent, {
        disableClose: true,
        panelClass: 'clientInfoPopup-panel',
        data: {
          title: coverage.title,
          content: coverage.details,
          info: true,
          closeIcon: true
        },
      });
    })
  };

  InfoDialogReadOnly(coverage) {
    const dialogRef = this.dialog.open(GlobalDialogComponent, {
      disableClose: true,
      panelClass: 'clientInfoPopup-panel',
      data: {
        title: coverage.descripcion,
        content: coverage.details,
        info: true,
        closeIcon: true
      },
    });
  };
}